module.exports = __webpack_public_path__ + "media/images/btn-arrow-bottom-1e0666e0b0956553d362b1a54ae32f7e.svg";